module.exports = __webpack_public_path__ + "images/sprites/tax_icons/tax_icon_default_63d9fedcc7e835f960f7008c68001773.png";